import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import type { HourPoint } from '../../types/weather';
import { chartTheme } from './chartTheme';

export function HourlyTempChart({ hourly }: { hourly: HourPoint[] }) {
  const data = hourly.map(h => ({ time: h.timeLocal, Temp: h.tempF, Feels: h.apparentF }));
  return (
    <div className="h-28">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 6, right: 12, bottom: 0, left: 4 }}>
          <CartesianGrid strokeDasharray="2 4" stroke={chartTheme.grid} vertical={false} />
          <XAxis dataKey="time" tick={chartTheme.tick} interval={3} stroke={chartTheme.grid} />
          <YAxis
            tick={chartTheme.tick}
            width={36}
            stroke={chartTheme.grid}
            domain={['dataMin - 2', 'dataMax + 2']}
            tickFormatter={(v: number) => `${Math.round(v)}°`}
          />
          <Tooltip
            contentStyle={chartTheme.tooltip.contentStyle}
            labelStyle={chartTheme.tooltip.labelStyle}
            itemStyle={chartTheme.tooltip.itemStyle}
            formatter={(v) => `${Math.round(Number(v))}°F`}
          />
          <Legend wrapperStyle={chartTheme.legend.wrapperStyle} iconSize={8} />
          <Line type="monotone" dataKey="Temp"  stroke="#f97316" dot={false} strokeWidth={2.5} />
          <Line type="monotone" dataKey="Feels" stroke="#fdba74" dot={false} strokeWidth={1.5} strokeDasharray="4 3" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
